<template>
    <div class="container">
        <div class="inner">
            <h3 class="content-headline">썸네일 게시판</h3>
        </div>
        <div class="board__search">
            <div class="board__search__box">
                <input type="text" placeholder="검색어를 입력해주세요">
                <button></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'WorkComponent',
}
</script>

<style scoped>
</style>
